// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-btn {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px 5px;
  margin: 2em auto;
  padding: 1.5rem;
  border: none;
  font-weight: 500;
  border-radius: 3px;
  cursor: pointer;
  min-width: 150px;
  font-size: 1.2rem;
  outline: none;
  background: #3498db;
  color: var(--color-fg);
}

.toasts {
  position: absolute;
  top: 2rem;
  right: 1rem;
  z-index: 1000;
}

.toast-notification {
  width: 350px;
  margin-bottom: 0.75rem;
  background: var(--color-bg);
  border-radius: 2px;
  box-shadow: 1px 7px 14px -5px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 1000;
}

.hide-toast {
  display: none;
}

.toast-notification .toast-content {
  font-weight: 400;
  color: var(--color-fg);
  padding: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0 1rem;
  font-family: Arial, Helvetica, sans-serif;
  z-index: 1000;
}

.toast-notification .toast-icon {
  background-color: var(--color-bg);
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.toast-notification .toast-icon i {
  font-size: 1.25rem;
}

.toast-notification .toast-progress {
  height: 2px;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.toast-notification .toast-progress-bar {
  background-color: var(--color-hover);
  height: 2px;
  animation: toastProgress 3s ease-in-out forwards;
}

.slide-in-slide-out {
  animation: slideInRight 0.3s ease-in-out forwards, slideOutRight 0.5s ease-in-out forwards 3s;
  transform: translateX(110%);
}

.slide-in-fade-out {
  animation: slideInRight 0.3s ease-in-out forwards, fadeOut 0.5s ease-in-out forwards 3s;
  transform: translateX(110%);
}

.wiggle-me {
  animation: wiggle 2s ease-in;
}

@keyframes slideInRight {
  0% {
    transform: translateX(110%);
  }
  75% {
    transform: translateX(-10%);
  }
  100% {
    transform: translateX(0%);
  }
}
@keyframes slideOutRight {
  0% {
    transform: translateX(0%);
  }
  25% {
    transform: translateX(-10%);
  }
  100% {
    transform: translateX(110%);
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes toastProgress {
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@keyframes wiggle {
  0%, 7% {
    transform: rotateZ(0);
  }
  15% {
    transform: rotateZ(-13deg);
  }
  20% {
    transform: rotateZ(9deg);
  }
  25% {
    transform: rotateZ(-10deg);
  }
  30% {
    transform: rotateZ(7deg);
  }
  35% {
    transform: rotateZ(-2deg);
  }
  40%, 100% {
    transform: rotateZ(0);
  }
}`, "",{"version":3,"sources":["webpack://./t2m-playground/src/utils/toasts.css"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAEA;EACI,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gDAAA;EACA,gBAAA;EACA,aAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,yCAAA;EACA,aAAA;AACJ;;AAEA;EACI,iCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AACJ;;AAEA;EACI,oCAAA;EACA,WAAA;EACA,gDAAA;AACJ;;AAEA;EACI,6FAAA;EACA,2BAAA;AACJ;;AAEA;EACI,uFAAA;EACA,2BAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI;IACI,2BAAA;EACN;EAEE;IACI,2BAAA;EAAN;EAGE;IACI,yBAAA;EADN;AACF;AAIA;EACI;IACI,yBAAA;EAFN;EAKE;IACI,2BAAA;EAHN;EAME;IACI,2BAAA;EAJN;AACF;AAOA;EACI;IACI,UAAA;EALN;EAQE;IACI,UAAA;EANN;AACF;AASA;EACI;IACI,WAAA;EAPN;EAUE;IACI,SAAA;EARN;AACF;AAWA;EAEI;IAEI,qBAAA;EAXN;EAcE;IACI,0BAAA;EAZN;EAeE;IACI,wBAAA;EAbN;EAgBE;IACI,0BAAA;EAdN;EAiBE;IACI,wBAAA;EAfN;EAkBE;IACI,yBAAA;EAhBN;EAmBE;IAEI,qBAAA;EAlBN;AACF","sourcesContent":[".toast-btn {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    gap: 10px 5px;\n    margin: 2em auto;\n    padding: 1.5rem;\n    border: none;\n    font-weight: 500;\n    border-radius: 3px;\n    cursor: pointer;\n    min-width: 150px;\n    font-size: 1.2rem;\n    outline: none;\n    background: #3498db;\n    color: var(--color-fg);\n}\n\n.toasts {\n    position: absolute;\n    top: 2rem;\n    right: 1rem;\n    z-index: 1000;\n}\n\n.toast-notification {\n    width: 350px;\n    margin-bottom: .75rem;\n    background: var(--color-bg);\n    border-radius: 2px;\n    box-shadow: 1px 7px 14px -5px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n    z-index: 1000;\n}\n\n.hide-toast {\n    display: none;\n}\n\n.toast-notification .toast-content {\n    font-weight: 400;\n    color: var(--color-fg);\n    padding: 1rem;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 0 1rem;\n    font-family: Arial, Helvetica, sans-serif;\n    z-index: 1000;\n}\n\n.toast-notification .toast-icon {\n    background-color: var(--color-bg);\n    color: #fff;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.toast-notification .toast-icon i {\n    font-size: 1.25rem;\n}\n\n.toast-notification .toast-progress {\n    height: 2px;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n}\n\n.toast-notification .toast-progress-bar {\n    background-color: var(--color-hover);\n    height: 2px;\n    animation: toastProgress 3s ease-in-out forwards;\n}\n\n.slide-in-slide-out {\n    animation: slideInRight 0.3s ease-in-out forwards, slideOutRight 0.5s ease-in-out forwards 3s;\n    transform: translateX(110%);\n}\n\n.slide-in-fade-out {\n    animation: slideInRight 0.3s ease-in-out forwards, fadeOut 0.5s ease-in-out forwards 3s;\n    transform: translateX(110%);\n}\n\n.wiggle-me {\n    animation: wiggle 2s ease-in;\n}\n\n@keyframes slideInRight {\n    0% {\n        transform: translateX(110%);\n    }\n\n    75% {\n        transform: translateX(-10%);\n    }\n\n    100% {\n        transform: translateX(0%);\n    }\n}\n\n@keyframes slideOutRight {\n    0% {\n        transform: translateX(0%);\n    }\n\n    25% {\n        transform: translateX(-10%);\n    }\n\n    100% {\n        transform: translateX(110%);\n    }\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes toastProgress {\n    0% {\n        width: 100%;\n    }\n\n    100% {\n        width: 0%;\n    }\n}\n\n@keyframes wiggle {\n\n    0%,\n    7% {\n        transform: rotateZ(0);\n    }\n\n    15% {\n        transform: rotateZ(-13deg);\n    }\n\n    20% {\n        transform: rotateZ(9deg);\n    }\n\n    25% {\n        transform: rotateZ(-10deg);\n    }\n\n    30% {\n        transform: rotateZ(7deg);\n    }\n\n    35% {\n        transform: rotateZ(-2deg);\n    }\n\n    40%,\n    100% {\n        transform: rotateZ(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
